import { purchaseOrders } from "@/api/purchaseOrder/usePurchaseOrder";
import { users } from "@/api/users/useUsersQuery";
import { LeftSpace } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { OrderItemsCreateForm } from "@/features/orderItems/form/CreateForm";
import { ArrivalDeliveryStockPlanForm } from "@/features/purchaseOrderItems/form/ArrivalDeliveryStockPlanForm";
import { ActionButtonBox } from "@/features/standard/ActionButtonBox";
import { ActionHeader } from "@/features/standard/ActionHeader";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { useLoader } from "@/hooks/useLoader";
import { getUserCodeByUser } from "@/utils/checkData";
import { translateWithPartnerType } from "@/utils/partnerType";
import { Button, Tabs } from "@mantine/core";
import {
  AuthSignupPost201ResponseEquipmentPurchaseOrderItem,
  ItemsGet200ResponseRowsInnerLotsInnerInventoriesInner,
} from "@sizlcorp/sizl-api-document/dist/models";
import { IconPlus } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OrderDetailActionBar } from "../header/OrderDetailActionBar";
import { OrderDetailHeader } from "../header/OrderDetailHeader";
import { OrderDetailTable } from "../table/OrderDetailTable";
import { OrderIncomingForm } from "./OrderIncomingForm";

const Detail = Object.assign(
  {},
  {
    Container: DetailContainer,
    Wrapper: DetailWrapper,
    Content: DetailContent,
    ActionBar: OrderDetailActionBar,
    ActionHeader: ActionHeader,
    ActionButtonBox: ActionButtonBox,
    ActionButton: Button,
    OrderItemsCreateForm: OrderItemsCreateForm,
  },
);

interface OrderDetailFormProps {
  purchaseOrderId: number | undefined;
}

export const OrderDetailForm = (params: OrderDetailFormProps) => {
  const { purchaseOrderId } = params;
  const userCode = getUserCodeByUser();
  const { t } = useTranslation();
  const { data: userInfo } = useQuery(users.who({}));
  const partnerType = userInfo?.data?.partner?.type;
  const { data: orderData } = useQuery(
    purchaseOrders.detail({
      purchaseOrderId: purchaseOrderId ?? 0,
      populate: ["location", "user", "partner", "purchaseOrderItems"],
    }),
  );

  const [isRowBtnActive, setIsRowBtnActive] = useState<boolean>(false);
  const [selectedRowsInform, setSelectedRowsInform] = useState<
    ItemsGet200ResponseRowsInnerLotsInnerInventoriesInner[]
  >([]);
  const [data, setData] = useState<
    AuthSignupPost201ResponseEquipmentPurchaseOrderItem[] | undefined
  >();
  const { openModal } = useModal();
  const { setLoading, LoadingOverlay } = useLoader();

  const handleRowSelect = (selectedRows: any, formatterPropsData: any) => {
    setIsRowBtnActive(selectedRows.size === 1);
    setData(formatterPropsData);
    setSelectedRowsInform(selectedRowsInform);
  };

  return (
    <>
      <Detail.Container>
        <LoadingOverlay />
        <Detail.ActionBar data={orderData?.data} />
        <Detail.Wrapper>
          <Detail.Content>
            {/* <OrderDetailDataHeader /> */}
            <OrderDetailHeader data={orderData?.data} />
            <Tabs defaultValue="order">
              <LeftSpace />
              <Tabs.List>
                <Tabs.Tab value="order">
                  {translateWithPartnerType(t, "orderItems.orderItems", partnerType)}
                </Tabs.Tab>
                {/* <Tabs.Tab value="history">{t("info.history")}</Tabs.Tab> */}
              </Tabs.List>
              <Tabs.Panel value="order">
                <Detail.ActionHeader>
                  <Detail.ActionButtonBox>
                    <Detail.ActionButton
                      leftIcon={<IconPlus />}
                      onClick={() =>
                        openModal(
                          <Detail.OrderItemsCreateForm orderId={orderData?.data?.id} />,
                          null,
                          t("common.additional", {
                            item: translateWithPartnerType(t, "orderItems.orderItems", partnerType),
                          }),
                        )
                      }
                    >
                      {t("common.additional", {
                        item: translateWithPartnerType(t, "orderItems.orderItems", partnerType),
                      })}
                    </Detail.ActionButton>
                    <Detail.ActionButton
                      leftIcon={<IconPlus />}
                      color="green"
                      disabled={!isRowBtnActive}
                      onClick={() =>
                        openModal(
                          <ArrivalDeliveryStockPlanForm formatterProps={data && data[0]} />,
                          null,
                          t("orderItems.incomingStockPlan"),
                        )
                      }
                    >
                      {t("orderItems.incomingStockPlan")}
                    </Detail.ActionButton>
                    <Detail.ActionButton
                      leftIcon={<IconPlus />}
                      color="green"
                      disabled={data?.length === 0}
                      onClick={() =>
                        openModal(
                          <OrderIncomingForm orderItems={data} setLoading={setLoading} />,
                          null,
                          t("inventory.incoming"),
                        )
                      }
                    >
                      {t("inventory.incoming")}
                    </Detail.ActionButton>
                  </Detail.ActionButtonBox>
                </Detail.ActionHeader>
                <OrderDetailTable onRowSelect={handleRowSelect} orderId={orderData?.data?.id} />
              </Tabs.Panel>
              <Tabs.Panel value="history">
                {"발주 항목"} {t("info.history")}
              </Tabs.Panel>
            </Tabs>
          </Detail.Content>
        </Detail.Wrapper>
      </Detail.Container>
    </>
  );
};
